import { useDrop } from 'react-dnd';

type DraggableCardProps = {
  children: React.ReactNode;
  onDrop: (item: any) => void;
  onDragOver: () => void;
  onDragLeave: () => void;
};

const DroppableArea = ({
  onDrop,
  children,
  onDragOver,
  onDragLeave,
}: DraggableCardProps) => {
  const [{ isOver }, drop] = useDrop({
    accept: 'CARD', // Specify the type of items that can be dropped
    drop: (item) => {
      onDrop(item);
    }, // Handle the drop event
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  });

  return (
    <div
      ref={drop}
      onDragOver={(e) => {
        e.preventDefault();
        onDragOver();
      }}
      onDragLeave={onDragLeave}
      style={{
        borderColor: isOver ? '#5557C9' : '',
        borderWidth: isOver ? '2px' : '',
        borderStyle: isOver ? 'dashed' : '',
        borderRadius: '8px',
      }}
    >
      {children}
    </div>
  );
};

export default DroppableArea;
